import React from "react";
import styled from "styled-components";

const CubeWrap = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
`;

const Cubes = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-end;
`;

const Cube = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  margin: 0 1rem;
  font-size: 1rem;

  &:after {
    content: attr(title);
    display: block;
    position: absolute;
    bottom: -3rem;
    left: 50%;
    transform: translateX(-50%);
  }
`;

const CubeOrange = styled(Cube)`
  width: var(--space-orange);
  height: var(--space-orange);
  background-color: #ebcc83;
`;

const CubeBlue = styled(Cube)`
  width: var(--space-blue);
  height: var(--space-blue);
  background-color: #a0e6eb;
`;

const CubeGreen = styled(Cube)`
  width: var(--space-green);
  height: var(--space-green);
  background-color: #c8eba0;
`;

const CubePurple = styled(Cube)`
  width: var(--space-purple);
  height: var(--space-purple);
  background-color: #a0afeb;
`;

const CubePink = styled(Cube)`
  width: var(--space-pink);
  height: var(--space-pink);
  background-color: #dbabe9;
`;

const CubeRed = styled(Cube)`
  width: var(--space-red);
  height: var(--space-red);
  background-color: #eb9595;
`;

const Spacing = () => (
  <>
    <CubeWrap>
      <Cubes>
        <CubeOrange title="XS"></CubeOrange>
        <CubeBlue title="S"></CubeBlue>
        <CubeGreen title="M"></CubeGreen>
        <CubePurple title="L"></CubePurple>
        <CubePink title="XL"></CubePink>
        <CubeRed title="XXL"></CubeRed>
      </Cubes>
    </CubeWrap>
  </>
);

export default Spacing;
